/** The public `/share/<token>` page needs no mk-auth session and is out of
 * Sentry's scope — callers must check this before any auth or telemetry setup runs. */
export function isShareRoute(): boolean {
  return window.location.pathname.startsWith("/share/");
}
